import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import MenuItemNameTypography from 'components/MenuItemNameTypography';
import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';

const StyledTypography = styled(MenuItemNameTypography)({
  textAlign: 'right',
  flex: 1
});

function MenuItemDetailPrice({ cost, hasInvestorDayFeature = false }) {
  const styles = { variant: MENU_ITEM_NAMES };

  return (
    !hasInvestorDayFeature && (
      <StyledTypography
        data-testid="price-preview"
        component="span"
        {...styles}
      >{`$${cost}`}</StyledTypography>
    )
  );
}

MenuItemDetailPrice.propTypes = {
  cost: PropTypes.string,
  hasInvestorDayFeature: PropTypes.bool
};

export default MenuItemDetailPrice;
